<template>
  <div>
    <section class="section pb-none">
      <the-search/>
    </section>

    <section class="section">
      <div class="container">
        <product-tabs/>

        <div class="columns" v-if="product !== null">
          <div class="column is-3">
            <article-index :product="product" class="box" />
          </div>

          <div class="column is-9">
            <div class="box">
              <router-view v-bind="{ product }" />
            </div>
          </div>
        </div>
        <loading-content v-else />
      </div>
    </section>
  </div>
</template>

<script>
import API from '@/api'
import TheSearch from '@/components/TheSearch'
import ProductTabs from '@/components/ProductTabs'
import ArticleIndex from '@/components/ArticleIndex'
import LoadingContent from '@/components/LoadingContent'

export default {
  name: 'ProductManual',
  components: {
    TheSearch,
    ProductTabs,
    ArticleIndex,
    LoadingContent
  },
  data () {
    return {
      isLoading: true,
      product: null
    }
  },
  mounted () {
    this.fetchProduct()
  },
  methods: {
    fetchProduct () {
      this.isLoading = true
      API.products.findBySlug(this.$route.params.product, product => {
        this.product = product
        this.isLoading = false
      })
    }
  },
  watch: {
    '$route.params.product' () {
      this.fetchProduct()
    }
  }
}
</script>
